exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Arrows-module__arrows__svg__EGNeX {\r\n    fill: #929292;\r\n}\r\n\r\n.Arrows-module__card__arrows__14Q0K:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.Arrows-module__card__arrows__14Q0K:hover .Arrows-module__arrows__svg__EGNeX {\r\n    fill: #16b6a1;\r\n}", ""]);

// exports
exports.locals = {
	"arrows__svg": "Arrows-module__arrows__svg__EGNeX",
	"card__arrows": "Arrows-module__card__arrows__14Q0K"
};